export default __webpack_public_path__ + "static/media/logo-v2.08f1c233.png";